<template>
  <div id="app" :class="isPC ? '' : 'noPC'">
    <div id="web_bg"></div>
    <router-view />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
export default {
  name: "App",
  data() {
    return {
      isPC: true,
    };
  },
  mounted() {
    // var userAgentInfo = navigator.userAgent;
    // var Agents = [
    //   "Android",
    //   "iPhone",
    //   "SymbianOS",
    //   "Windows Phone",
    //   "iPad",
    //   "iPod",
    // ];
    // this.isPC = true;
    // for (var v = 0; v < Agents.length; v++) {
    //   if (userAgentInfo.indexOf(Agents[v]) > 0) {
    //     this.isPC = false;
    //     break;
    //   }
    // }

    var screen_width = window.screen.width;
    var screen_height = window.screen.height;
    if(screen_height>screen_width){
      this.isPC=false;
    }
    console.log(this.isPC)
    this.SET_PC_STATE(this.isPC)
  },
  methods: {
    ...mapMutations({
      SET_PC_STATE: "rank/SET_PC_STATE",
    }),


},
};
</script>

<style lang="scss">
@import "./assets/style/main.scss";
@import "./assets/style/noPC.scss";
html,
body {
  margin: 0;
  width: 100%;
  height: 100%;
}
#app {
  font-family: "Microsoft YaHei";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
#web_bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-width: 1200px;
  z-index: -10;
  zoom: 1;
  background-image: url("./assets/BG.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue